<template>
  <div id="factoryPc">
    <div class="main_bg">
      <div class="banner">
        <img src="../../assets/factory/slices/背景.jpg" alt style="width:100%" />
      </div>
      <div class="main2-content">
        <div
          class="dec"
        >9月，上汽大众长沙工厂云体验开启，多位技术专家、质量工程师现身云端，从冲压、车身、油漆、总装汽车制造的四大工艺以及严苛的质保环节入手，为线上参观者带来柯迪亚克家族的制造及工艺品质亮点。</div>
        <div style="position: relative;height: 80px;">
          <div class="dec-detail" @click="handleDetail">查看详情 ></div>
        </div>
        <div class="shipin-content">
          <!--  <img src="../../assets/factory/slices/矩形 4 拷贝 2.png" alt="" style="width:100%"> -->
          <div>
            <video
              id="shipin-video"
              class="shipin-video"
              controls
              controlslist="nodownload"
              :disablePictureInPicture="true"
              preload="auto"
              src="https://www.csvw.com/u/cms/www/202009/05172802ez0A.mp4"
              type="video/mp4"
              style="width:100%;"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
            ></video>
          </div>
          <!-- <div class="one" v-show="showone">
            <div class="shipin-play" @click="handlePlayAgain"></div>
            <div class="shipin-gushixian" @click="handleTwo"></div>
          </div>-->

          <div class v-show="showone">
            <div class="shipin-gushixian" @click="handleTwo"></div>
          </div>

          <div class="two" v-show="showtwo">
            <div class="model-content"></div>
            <div class="moshi-content" v-show="tip1">
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(1,2)">开始参观</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip2">
              <div class="shipin-title">请选择你想要的视角？</div>
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(2,'2a')">故事模式</div>
                </div>
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(3,3)">体验模式</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip2a">
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(3,3)">体验模式</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip3">
              <div class="shipin-title">请选择接下来的路线？</div>
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(4,'3a')">总装车间</div>
                </div>
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(5,4)">车身车间</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip3a">
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(5,4)">车身车间</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip4">
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(61,5)">魅夜红</div>
                </div>
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(62,5)">冰雪白</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip5">
              <div class="shipin-title">不属于油漆车间的工艺亮点是？</div>
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handleAnwser(1)">空腔注蜡</div>
                </div>
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handleAnwser(2)">E-shuttle输送</div>
                </div>
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(7,7)">非接触光学激光测量</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip6">
              <div class="shipin-title">这个不是正确答案哦~再想想吧</div>
              <div class="shipin-btn-content">
                <div class="shipin-btn1" style="position: relative;">
                  <div class="shipin-txt" @click="handleAnwser(1)">空腔注蜡</div>
                  <img
                    src="../../assets/factory/slices4/差.png"
                    class="shipin-disable"
                    v-show="answer==1"
                  />
                </div>
                <div class="shipin-btn1" style="position: relative;">
                  <div class="shipin-txt" @click="handleAnwser(2)">E-shuttle输送</div>
                  <img
                    src="../../assets/factory/slices4/差.png"
                    class="shipin-disable"
                    v-show="answer==2"
                  />
                </div>
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(7,7)">非接触光学激光测量</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip7">
              <div class="shipin-title">请选择接下来的路线？</div>
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(8,'7a')">吃个饭先</div>
                </div>
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(9,8)">验个车先</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip7a">
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(9,8)">去验车</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip8">
              <div
                class="shipin-title"
                style="cursor: pointer;"
                @click="handleCaiDan(9,9)"
              >工厂参观告一段落，别走开后面还有彩蛋</div>
            </div>

            <div class="moshi-content" v-show="tip9">
              <div class="shipin-btn-content">
                <div class="shipin-btn1">
                  <div class="shipin-txt" @click="handlePlay(10,10)">彩蛋</div>
                </div>
              </div>
            </div>

            <div class="moshi-content" v-show="tip10">
              <div class="shipin-title">请选择您想重温的路线？</div>
              <div class="shipin-btn-content">
                <div class="shipin-btn1" style="width: 170px;">
                  <div class="shipin-txt" @click="handlePlay(3,3)">冲压车间</div>
                </div>
                <div class="shipin-btn1" style="width: 170px;">
                  <div class="shipin-txt" @click="handlePlay(5,4)">车身车间</div>
                </div>
                <div class="shipin-btn1" style="width: 170px;">
                  <div class="shipin-txt" @click="handlePlay(61,5)">油漆车间</div>
                </div>
                <div class="shipin-btn1" style="width: 170px;">
                  <div class="shipin-txt" @click="handlePlay(7,7)">总装车间</div>
                </div>
                <div class="shipin-btn1" style="width: 170px;">
                  <div class="shipin-txt" @click="handlePlay(9,8)">质保中心</div>
                </div>
              </div>
            </div>

            <div class="shipin-gushixian" @click="handleTwo"></div>
          </div>

          <div class="three" v-show="showthree">
            <div class="model-content2"></div>
            <div class="gushi-content">
              <div class="model-tip">
                <div class="img-juxing"></div>
                <div class="img-text" style="margin-left: 10px">点击后进入视频</div>
              </div>

              <div class="model-close" @click="handleClose">
                <div class="img-text" style="margin-left: 10px">×</div>
              </div>

              <div
                class="juxing"
                :class="{'juxing-active': juxing1}"
                style="left:42px;top:234px;"
                @click="playShipin(1,2)"
              >
                <div class="img-btn"></div>
                <div class="text-btn">开始参观</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing2}"
                style="left:199px;top:159px;"
                @click="playShipin(2,'2a')"
              >
                <div class="img-btn"></div>
                <div class="text-btn">注意事项</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing3}"
                style="left:199px;top:305px;"
                @click="playShipin(3,3)"
              >
                <div class="img-btn"></div>
                <div class="text-btn">参观冲压车间</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing4}"
                style="left:367px;top:231px;"
                @click="playShipin(4,'3a')"
              >
                <div class="img-btn"></div>
                <div class="text-btn">往哪走？</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing5}"
                @click="playShipin(5,4)"
                style="left:367px;top:381px;"
              >
                <div class="img-btn"></div>
                <div class="text-btn">参观车身车间</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing61}"
                @click="playShipin(61,5)"
                style="left:537px;top:305px;width: 196px;"
              >
                <div class="img-btn"></div>
                <div class="text-btn">参观油漆车间（魅夜红）</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing62}"
                @click="playShipin(62,5)"
                style="left:537px;top:453px;width: 196px;"
              >
                <div class="img-btn"></div>
                <div class="text-btn">参观油漆车间（冰雪白）</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing7}"
                @click="playShipin(7,7)"
                style="left:737px;top:381px;"
              >
                <div class="img-btn"></div>
                <div class="text-btn">参观总装车间</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing9}"
                @click="playShipin(9,8)"
                style="left:912px;top:305px;width: 158px;"
              >
                <div class="img-btn"></div>
                <div class="text-btn">验车，去质保</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing8}"
                @click="playShipin(8,'7a')"
                style="left:912px;top:453px;width: 158px;"
              >
                <div class="img-btn"></div>
                <div class="text-btn">吃个饭先，去食堂</div>
              </div>
              <div
                class="juxing"
                :class="{'juxing-active': juxing10}"
                @click="playShipin(10,10)"
                style="left:1077px;top:380px;width: 121px;"
              >
                <div class="img-btn" style="margin-left: 35px;"></div>
                <div class="text-btn">彩蛋</div>
              </div>

              <div class="line-up" style="left:103px;top:174px;"></div>
              <div class="line-down" style="left:103px;top:272px;"></div>

              <div class="line-up" style="left:271px;top:245px;"></div>
              <div class="line-down" style="left:271px;top:343px;"></div>

              <div class="line-up" style="left:440px;top:322px;"></div>
              <div class="line-down" style="left:440px;top:418px;"></div>

              <div class="line-up" style="left:816px;top:322px;"></div>
              <div class="line-down" style="left:816px;top:418px;"></div>

              <div class="xian-up" style="left:729px;top:419px;"></div>
              <div class="xian-down" style="left:729px;top:322px;"></div>
            </div>
          </div>
        </div>

        <div id="video1" class="clearfix">
          <!--  <video class="lvideo" controls autoplay="true" loop="loop" preload="auto" src="../../assets/factory/shipin/8.食堂824.mp4" type="video/mp4"></video>
          <video class="lvideo" controls="" autoplay="true" loop="loop" preload="auto" src="./tk.mp4" type="video/mp4" poster="../../assets/factory/images/about/oldkv.jpg"></video>-->
        </div>
        <div style="height: 150px;"></div>
        <div>
          <div class="qiche-title">柯迪亚克家族工艺亮点</div>
          <div style="width: 90px;height: 5px;background: #4697F2;margin: 20px auto 200px auto"></div>
        </div>
        <div class="qiche-content">
          <div style="width: 1140px;margin: auto;">
            <div style="width: 900px;margin: 0px 0px 0px 240px;position: relative;">
              <div class="qiche-img"></div>
              <!-- <img src="../../assets/factory/slices/曲线 2.png" alt="汽车" width="100%" /> -->

              <div class="dian-detail">
                <div class="dian-detail-title">点击右侧车辆查看详情</div>
                <div
                  style="cursor: pointer;"
                  @click="clickdain(5)"
                  @mouseenter="clickdain(5)"
                >
                  <span class="dian-detail-number">1</span>
                  <span class="dian-detail-text">三维腰线冲压工艺</span>
                </div>
                <div
                  style="cursor: pointer;"
                  @click="clickdain(4)"
                  @mouseenter="clickdain(4)"
                >
                  <span class="dian-detail-number">2</span>
                  <span class="dian-detail-text">激光焊接工艺</span>
                </div>
                <div
                  style="cursor: pointer;"
                  @click="clickdain(3)"
                  @mouseenter="clickdain(3)"
                >
                  <span class="dian-detail-number">3</span>
                  <span class="dian-detail-text">全方位防腐工艺</span>
                </div>
                <div
                  style="cursor: pointer;"
                  @click="clickdain(6)"
                  @mouseenter="clickdain(6)"
                >
                  <span class="dian-detail-number">4</span>
                  <span class="dian-detail-text">个性化油漆工艺</span>
                </div>
                <div
                  style="cursor: pointer;"
                  @click="clickdain(2)"
                  @mouseenter="clickdain(2)"
                >
                  <span class="dian-detail-number">5</span>
                  <span class="dian-detail-text">精准组装工艺</span>
                </div>
                <div
                  style="cursor: pointer;"
                  @click="clickdain(1)"
                  @mouseenter="clickdain(1)"
                >
                  <span class="dian-detail-number">6</span>
                  <span class="dian-detail-text">严格品质管控</span>
                </div>
              </div>

              <span class="dian dian-active dian1" style="left: 120px;top: 90px;">6</span>
              <div
                class="dianarea"
                @click="clickdain(1)"
                @mouseenter="clickdain(1)"
                @mouseout="clickrest2"
                style="left: 120px;top: 90px;"
              ></div>
              <span class="dian dian-active1 dian2" style="left: 300px;top: 5px;">5</span>
              <div
                class="dianarea"
                @click="clickdain(2)"
                @mouseenter="clickdain(2)"
                @mouseout="clickrest2"
                style="left: 300px;top: 5px;"
              ></div>
              <span class="dian dian-active2 dian3" style="left: 330px;top: 225px;">3</span>
              <div
                class="dianarea"
                @click="clickdain(3)"
                @mouseenter="clickdain(3)"
                @mouseout="clickrest2"
                style="left: 330px;top: 225px;"
              ></div>
              <span class="dian dian-active1 dian4" style="left: 520px;top: -10px;">2</span>
              <div
                class="dianarea"
                @click="clickdain(4)"
                @mouseenter="clickdain(4)"
                @mouseout="clickrest2"
                style="left: 520px;top: -10px;"
              ></div>
              <span class="dian dian-active dian5" style="left: 500px;top: 80px;">1</span>
              <div
                class="dianarea"
                @click="clickdain(5)"
                @mouseenter="clickdain(5)"
                @mouseout="clickrest2"
                style="left: 500px;top: 80px;"
              ></div>
              <span class="dian dian-active2 dian6" style="left: 700px;top: 35px;">4</span>
              <div
                class="dianarea"
                @click="clickdain(6)"
                @mouseenter="clickdain(6)"
                @mouseout="clickrest2"
                style="left: 700px;top: 35px;"
              ></div>
              <div
                class="dian-text dian1-text"
                v-show="dian1"
                style="left: 150px;top: -170px;height: 280px;"
              >
                <div class="text-title">严格品质管控</div>
                <div
                  class="text-dec"
                >柯迪亚克家族的车辆不仅需要通过9种不同路况，用于检测车内是否会产生异响，还要模拟出数倍于特大暴雨的环境，以检测车辆的防水性能。只有经受住这样多重严苛检测考验的车辆，方能达到其出厂标准。</div>
              </div>
              <div class="dian-text dian2-text" v-show="dian2" style="left: 330px;top: -200px;">
                <div class="text-title">精准组装工艺</div>
                <div
                  class="text-dec"
                >柯迪亚克家族仪表盘安装、风挡玻璃涂胶等都由机器人完成，确保了装配的精确性。高精度电动枪螺栓拧紧工艺极大提高了精准度，还可实现数据存储、识别，并具有可追溯性，时效长达15年之久。</div>
              </div>
              <div
                class="dian-text dian3-text"
                v-show="dian3"
                style="left: 360px;top: -160px;height: 404px;"
              >
                <div class="text-title">全方位防腐工艺</div>
                <div
                  class="text-dec"
                >柯迪亚克家族的车身大量采用了双面镀锌高张力钢板，并通过覆盖电泳层，接缝处喷涂PVC及空腔注蜡等工艺，彻底消除车身被腐蚀的后顾之忧。</div>
              </div>
              <div class="dian-text dian4-text" v-show="dian4" style="left: 26px;top: -190px;">
                <div class="text-title">激光焊接工艺</div>
                <div
                  class="text-dec"
                >柯迪亚克家族大量运用了激光焊接工艺。激光焊接可以使两块钢板实现原子层面的结合，相较传统点焊，大幅提升车身刚性，还带来接缝美观、重量减轻等优点。</div>
              </div>
              <div
                class="dian-text dian5-text"
                v-show="dian5"
                style="left: 6px;top: -170px;height: 270px;"
              >
                <div class="text-title">三维腰线冲压工艺</div>
                <div
                  class="text-dec"
                >柯迪亚克的三维力量腰线，源于业界最高标准的德国舒勒6工序高速冲压线，相较业内普遍应用的5工序冲压线，6工序冲压线可以实现更复杂造型、更精准尺寸的打造。</div>
              </div>
              <div class="dian-text dian6-text" v-show="dian6" style="left: 206px;top: -170px;">
                <div class="text-title">个性化油漆工艺</div>
                <div
                  class="text-dec"
                >柯迪亚克家族的车身颜色多达7种，可为不同客户提供个性化颜色。其采用的面漆喷涂，烘干等工艺，也充分保证了色漆膜的固化和清漆的附着，大大提高了车身抗紫外线能力。</div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 116px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config";
export default {
  name: "factoryPc",
  components: {},
  data() {
    return {
      // 膜层控制
      showone: false,
      showtwo: true,
      showthree: false,

      // tip控制
      tip1: true,
      tip2: false,
      tip3: false,
      tip4: false,
      tip5: false,
      tip6: false,
      tip7: false,
      tip8: false,
      tip9: false,
      tip10: false,
      // tip辅助控制
      tip2a: false,
      tip3a: false,
      tip7a: false,

      answer: 0,

      // 故事线控制
      juxing1: false,
      juxing2: false,
      juxing3: false,
      juxing4: false,
      juxing5: false,
      juxing61: false,
      juxing62: false,
      juxing7: false,
      juxing8: false,
      juxing9: false,
      juxing10: false,

      // 播发视频key
      index: "1",

      // 远程视频地址 https://www.csvw.com/csvw/thirdpart/video/1.开篇824.mp4
      // 跳转详情
      decDetail: config.decDetail,
      // 视频控制
      videoList: config.videoList,

      // 车子部件控制
      dian1: false,
      dian2: false,
      dian3: false,
      dian4: false,
      dian5: false,
      dian6: false
    };
  },
  methods: {
    handleDetail() {
      window.open(this.decDetail, "_self");
    },
    // 三个膜层
    showrest() {
      this.showone = false;
      this.showtwo = false;
      this.showthree = false;
    },
    // 播放
    onPlayerPlay(e) {
      this.showrest();
    },
    // 暂停
    onPlayerPause(e) {
      this.showrest();
    },
    // 播放结束
    onPlayerEnded(e) {
      this.showrest();
      this.showtwo = true;
    },
    handlePlayAgain() {
      this.showrest();
      document.getElementById("shipin-video").play();
    },
    // tip重置状态
    tiprest() {
      this.tip1 = false;
      this.tip2 = false;
      this.tip3 = false;
      this.tip4 = false;
      this.tip5 = false;
      this.tip6 = false;
      this.tip7 = false;
      this.tip8 = false;
      this.tip9 = false;
      this.tip10 = false;
      this.tip2a = false;
      this.tip3a = false;
      this.tip7a = false;

      this.answer = 0;
    },

    // 弹出彩蛋
    handleCaiDan(val, val2) {
      this.showrest();
      this.showtwo = true;
      this.clickrest();
      this.tiprest();
      this.index = val;
      this["juxing" + val] = true;
      this["tip" + val2] = true;
    },

    // 播放val-播发视频，val2-显示tip
    handlePlay(val, val2) {
      this.showrest();
      this.clickrest();
      this.tiprest();
      this.index = val;
      this["juxing" + val] = true;
      this["tip" + val2] = true;
      document.getElementById("shipin-video").src = this.videoList[val];
      document.getElementById("shipin-video").play();
    },

    // 回答问题
    handleAnwser(val) {
      this.tiprest();
      this.tip6 = true;
      this.answer = val;
    },

    // 关闭
    handleClose() {
      this.showrest();
    },

    handleOne() {
      this.showrest();
      this.showtwo = true;
    },

    // 显示故事线面板
    handleTwo() {
      this.showrest();
      this.showthree = true;
    },
    // 故事线重置状态
    clickrest() {
      this.juxing1 = false;
      this.juxing2 = false;
      this.juxing3 = false;
      this.juxing4 = false;
      this.juxing5 = false;
      this.juxing61 = false;
      this.juxing62 = false;
      this.juxing7 = false;
      this.juxing8 = false;
      this.juxing9 = false;
      this.juxing10 = false;
    },
    // 播发视频val-播发视频，val2-显示tip
    playShipin(val, val2) {
      this.showrest();
      this.clickrest();
      this.tiprest();
      this.index = val;
      this["juxing" + val] = true;
      this["tip" + val2] = true;
      document.getElementById("shipin-video").src = this.videoList[val];
      document.getElementById("shipin-video").play();
    },
    // 汽车框文字重置状态
    clickrest2() {
      this.dian1 = false;
      this.dian2 = false;
      this.dian3 = false;
      this.dian4 = false;
      this.dian5 = false;
      this.dian6 = false;
    },
    clickdain(val) {
      this.clickrest2();
      this["dian" + val] = true;
    }
  }
};
</script>

<style lang="less" scoped>
#factoryPc {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
}

//底纹
.main_bg {
  width: 100%;
  min-width: 1200px;
  background: url("../../assets/factory/slices/底纹.png");
}

// 文字描述
.dec {
  text-indent: 2em;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #343434;
  line-height: 44px;
  margin-top: 100px;
  margin-bottom: 10px;
}

.dec-detail {
  height: 22px;
  line-height: 22px;
  border: 1px solid #333333;
  right: 20px;
  position: absolute;
  padding: 5px 13px;
  cursor: pointer;
}

.main2-content {
  width: calc(100% - 60px);
  margin: 0px 30px;
}

.shipin-content {
  position: relative;
}

.one,
.two,
.three {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

// 播放按钮
.shipin-play {
  position: absolute;
  left: 46%;
  top: 40%;
  width: 100px;
  height: 100px;
  background: url("../../assets/factory/slices/播放(1).png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

// 故事线按钮
.shipin-gushixian {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 325px;
  height: 76px;
  background: url("../../assets/factory/slices/故事线.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  z-index: 9;
}

// 模式容器
.moshi-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1000px;
  z-index: 9;
}

.shipin-title {
  font-size: 48px;
  font-family: FZYouHeiS-L1-GB;
  color: #ffffff;
  text-align: center;
  margin-bottom: 40px;
}

// 按钮容器
.shipin-btn-content {
  display: flex;
  justify-content: space-around;
  align-content: space-around;
}

// 按钮1
.shipin-btn1 {
  width: 288px;
  height: 103px;
  background: url("../../assets/factory/slices2/组 20.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

// 按钮2
.shipin-btn2 {
  position: absolute;
  left: 888px;
  top: 398px;
  width: 288px;
  height: 103px;
  background: url("../../assets/factory/slices2/组 20.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.shipin-txt {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 103px;
  text-align: center;
}

.shipin-disable {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

// 视频遮盖膜层
.model-content {
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.6;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 8;
}

// 全图膜层
.model-content2 {
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.6;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 8;
}

// 故事线膜层
.gushi-content {
  position: relative;
  width: 1240px;
  height: 603px;
  background: #000000;
  opacity: 0.8;
  border-radius: 10px;
  margin: 100px auto;
  z-index: 9;
}

// 膜层标题
.model-tip {
  position: absolute;
  left: 25px;
  top: 64px;
  width: 300px;
  height: 40px;

  .img-juxing {
    width: 49px;
    height: 23px;
    background: url("../../assets/factory/slices3/矩形 16 拷贝 2.png") no-repeat;
    display: inline-block;
    margin-left: 20px;
    margin-right: 5px;
    margin-top: 8px;
  }

  .img-text {
    height: 38px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 38px;
    display: inline-block;
    position: absolute;
    top: 0px;
  }
}

// 膜层关闭
.model-close {
  position: absolute;
  right: 0px;
  top: -40px;
  width: 40px;
  height: 40px;
  cursor: pointer;

  // 关闭
  .img-close {
    width: 49px;
    height: 23px;
    background: url("../../assets/factory/slices3/矩形 16 拷贝 2.png") no-repeat;
    display: inline-block;
    margin-left: 20px;
    margin-right: 5px;
  }

  .img-text {
    height: 38px;
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 38px;
    display: inline-block;
    position: absolute;
    top: 0px;
  }
}

// 圆角
.yuanjiao {
  position: absolute;
  left: 142px;
  top: 234px;
  width: 126px;
  height: 40px;
  background: url("../../assets/factory/slices3/圆角矩形 2.png") no-repeat;
  background-size: 100% 100%;

  // 文字
  .text-btn {
    height: 38px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 38px;
    display: inline-block;
    position: absolute;
    top: 0px;
  }
}

// 矩形
.juxing {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 143px;
  height: 40px;
  background: url("../../assets/factory/slices3/矩形 16.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;

  // 播放图标
  .img-btn {
    width: 13px;
    height: 13px;
    background: url("../../assets/factory/slices3/播放.png") no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    margin-left: 20px;
    margin-right: 5px;
    margin-top: 12px;
  }

  // 文字
  .text-btn {
    height: 38px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 38px;
    display: inline-block;
    position: absolute;
    top: 0px;
  }
}

// 选中
.juxing-active {
  position: absolute;
  width: 143px;
  height: 40px;
  background: url("../../assets/factory/slices3/矩形 16(1).png") no-repeat;
  background-size: 100% 100%;

  // 正在播放图标
  .img-btn {
    background: url("../../assets/factory/slices3/播放中.png") no-repeat;
  }

  .text-btn {
    color: #4798f2;
  }
}

// 向上箭头
.line-up {
  position: absolute;
  width: 89px;
  height: 61px;
  background: url("../../assets/factory/slices3/组 20(1).png") no-repeat;
}

// 向下箭头
.line-down {
  position: absolute;
  width: 91px;
  height: 62px;
  background: url("../../assets/factory/slices3/组 20(2).png") no-repeat;
}

// 向上线
.xian-up {
  position: absolute;
  width: 89px;
  height: 61px;
  background: url("../../assets/factory/slices3/形状 10 拷贝(1).png") no-repeat;
}

// 向下箭头
.xian-down {
  position: absolute;
  width: 91px;
  height: 62px;
  background: url("../../assets/factory/slices3/形状 10 拷贝.png") no-repeat;
}

// 第三部分车子
.qiche-content {
  position: relative;
  width: 100%;
  height: 420px;
}

.qiche-title {
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  text-align: center;
}

.dian {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-color: #afafaf;
  border-radius: 50%;
  cursor: pointer;
  margin: 20px;
  color: #fff;
  text-align: center;
  // background: url("../../assets/factory/slices/椭圆 1 拷贝 3.png") no-repeat;
  // background-size: 100%;
}

.dian1 {
  left: 396px;
  top: 134px;
}

.dian2 {
  left: 648px;
  top: 33px;
}

.dian3 {
  left: 672px;
  top: 312px;
}

.dian4 {
  left: 1017px;
  top: 3px;
}

.dian5 {
  left: 1004px;
  top: 126px;
}

.dian6 {
  left: 1237px;
  top: 81px;
}

// 点击区域
.dianarea {
  position: absolute;
  width: 60px;
  height: 60px;
  left: 0px;
  top: 0px;
  background: transparent;
  cursor: pointer;
  z-index: 1;
}

/* 设置动画前颜色 */
// .dian-active:before,
// .dian-active1:before,
// .dian-active2:before {
//   background: radial-gradient(circle, #e1edfa, #4697f2);
// }

// /* 设置动画后颜色 */
// .dian-active:after,
// .dian-active1:after,
// .dian-active2:after {
//   background-color: #AFAFAF;
// }

// /* 设置动画 */
// .dian-active:after {
//   content: "";
//   width: 48px;
//   height: 48px;
//   margin-left: -24px;
//   margin-top: -24px;
//   position: absolute;
//   left: 50%;
//   top: 50%;
//   border-radius: 50%;
//   animation: warn 3s ease-out 0s infinite;
// }

// .dian-active1:after {
//   content: "";
//   width: 48px;
//   height: 48px;
//   margin-left: -24px;
//   margin-top: -24px;
//   position: absolute;
//   left: 50%;
//   top: 50%;
//   border-radius: 50%;
//   animation: warn 3s ease-out 1s infinite;
// }

// .dian-active2:after {
//   content: "";
//   width: 48px;
//   height: 48px;
//   margin-left: -24px;
//   margin-top: -24px;
//   position: absolute;
//   left: 50%;
//   top: 50%;
//   border-radius: 50%;
//   animation: warn 3s ease-out 2s infinite;
// }

// /* @keyframes 闪烁点效果 */
// @keyframes warn {
//   0% {
//     transform: scale(0.5);
//     opacity: 1;
//   }

//   40% {
//     opacity: 0.4;
//   }

//   100% {
//     transform: scale(1);
//     opacity: 0;
//   }
// }

// 汽车文字框
.dian-text {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 526px;
  height: 224px;
  background: url("../../assets/factory/slices2/组 20(1).png") no-repeat;

  .text-title {
    display: none;
    width: 461px;
    height: 18px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bolder;
    color: #fefefe;
    line-height: 26px;
    margin: 20px 30px 0px 30px;
  }

  .text-dec {
    display: none;
    width: 461px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fefefe;
    line-height: 24px;
    margin: 10px 30px 0px 30px;
  }
}

.dian1-text {
  left: 396px;
  top: -110px;
  background: url("../../assets/factory/slices5/6.png") no-repeat;
}

.dian2-text {
  left: 648px;
  top: -224px;
  background: url("../../assets/factory/slices5/5.png") no-repeat;
}

.dian3-text {
  left: 672px;
  top: 60px;
  background: url("../../assets/factory/slices5/1.png") no-repeat;
}

.dian4-text {
  left: 1017px;
  top: -250px;
  background: url("../../assets/factory/slices5/3.png") no-repeat;
}

.dian5-text {
  left: 1004px;
  top: -130px;
  background: url("../../assets/factory/slices5/4.png") no-repeat;
}

.dian6-text {
  left: 730px;
  top: -170px;
  background: url("../../assets/factory/slices5/2.png") no-repeat;
}

.dian-detail {
  position: absolute;
  top: -150px;
  left: -240px;
  .dian-detail-title {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    line-height: 60px;
  }
  .dian-detail-number {
    font-size: 16px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: #afafaf;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    color: #fff;
    margin-right: 12px;
  }
  .dian-detail-text {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
  }
}

.qiche-img {
  background: url("../../assets/factory/slices/曲线 2.png");
  width: 900px;
  height: 315px;
  background-size: 1200px 315px;
  background-position-x: -175px;
}
</style>
